export const loadScript = (url: string, id?: string, onload?: () => void) => {
    if (id && document.querySelector(`#${id}`)) {
        console.log("Script already loaded, skipping load of this");
        return;
    }

    const element = document.createElement("script");
    element.type = "text/javascript";
    element.src = url;
    if (id) {
        element.id = id;
    }

    document.head.append(element);
    if (onload) {
        element.addEventListener("load", onload);
    }
};
